import React from "react";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import IconEllipsis from "../../../assets/icon_ellipsis.svg";

import { useAppInstallModal } from "../../../store/useAppInstallModal";
import { useMounted } from "../../../hook/useMounted";
import { openAppAndAction } from "../../../util/util";
import { isMobile as isMobileUtil } from "../../../util/navigator";
import { sellerUrl, uploadUrl } from "../../../util/url";
import Share from "../../../component/share/Share";

/**
 * Renders profile action buttons.
 */
export default function ProfileButtons({
  isMe,
  userAgent,
  hostname,
  seller,
  sellerTab,
}) {
    const navigate = useNavigate();
    const { openModal } = useAppInstallModal();
    const isMounted = useMounted();
    const mobile = isMobileUtil(userAgent);

  const handleUploadClick = (e) => {
    e.preventDefault();
    if (mobile) {
      alert("모바일에서는 지원하지 않는 기능입니다.");
      return;
    }
    navigate(uploadUrl());
  };

  const handleAppInstallModal = (e, message) => {
    if (e && e.preventDefault) e.preventDefault();
    openAppAndAction(() => openModal(message), null, 1000);
  };

  if (isMe) {
    return (
      <div className="Profile-buttons">
        <button className="Profile-gray-button" onClick={handleUploadClick}>
          업로드
        </button>
        <Link className="Profile-gray-button" to="/my/purchased">
          구매내역
        </Link>
        <Link className="Profile-image-button" to="/my/settings">
          <img src={IconEllipsis} alt="setting" />
        </Link>
      </div>
    );
  }

  return (
    <div className="Profile-buttons">
      <button
        className="Profile-black-button"
        onClick={(e) =>
          handleAppInstallModal(
            e,
            "팔로우는 앱에서!\n더 많은 셀러들을 만나보세요!",
          )
        }
      >
        팔로우
      </button>
      <button
        className="Profile-gray-button"
        onClick={(e) =>
          handleAppInstallModal(
            e,
            "채팅은 앱에서!\n더 많은 셀러들을 만나보세요!",
          )
        }
      >
        채팅하기
      </button>
      <div>
        {isMounted && (
          <Share
            hostname={hostname}
            path={sellerUrl(seller, sellerTab)}
            text={`${seller.user.nickname} (@${seller.user.username}) on FruitsFamily`}
          />
        )}
      </div>
    </div>
  );
}

ProfileButtons.propTypes = {
  isMe: PropTypes.bool.isRequired,
  userAgent: PropTypes.string,
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    rating: PropTypes.number,
    is_certified: PropTypes.bool,
    user: PropTypes.shape({
      username: PropTypes.string.isRequired,
      nickname: PropTypes.string.isRequired,
      bio: PropTypes.string,
      resizedBigImage: PropTypes.string,
      resizedBigCoverImage: PropTypes.string,
      follower_count: PropTypes.number.isRequired,
      following_count: PropTypes.number.isRequired,
      isBusiness: PropTypes.bool,
    }),
    seller: PropTypes.shape({
      is_tester: PropTypes.bool,
      is_certified: PropTypes.bool,
      product_count: PropTypes.number,
    }),
  }).isRequired,
  sellerTab: PropTypes.symbol,
  hostname: PropTypes.string.isRequired,
};
